import { Updater, route, router } from 'widgets-for-react'
import { Routes } from '../../../utils/routes'
import { RootState } from '../rootState'
import { routesArray } from './routesUtils'
import { Pages, routeUpdaters } from './routesState'

export const routeWidgets = (language: string): Routes<RootState, Pages> => {
  const localizedRouteUpdaters = routeUpdaters(language)
  return {
    notFound: route(
      localizedRouteUpdaters.notFound.url,
      localizedRouteUpdaters.notFound.jumpTo
    ),
    homeRedirect: route(
      localizedRouteUpdaters.homeRedirect.url,
      localizedRouteUpdaters.homeRedirect.jumpTo
    ),
    home: route(
      localizedRouteUpdaters.home.url,
      localizedRouteUpdaters.home.jumpTo
    ),
    componentOverview: route(
      localizedRouteUpdaters.componentOverview.url,
      localizedRouteUpdaters.componentOverview.jumpTo
    ),
    componentDetail: route(
      localizedRouteUpdaters.componentDetail.url,
      localizedRouteUpdaters.componentDetail.jumpTo
    ),
    componentEdit: route(
      localizedRouteUpdaters.componentEdit.url,
      localizedRouteUpdaters.componentEdit.jumpTo
    ),
    blogOverview: route(
      localizedRouteUpdaters.blogOverview.url,
      localizedRouteUpdaters.blogOverview.jumpTo
    ),
    blogDetail: route(
      localizedRouteUpdaters.blogDetail.url,
      localizedRouteUpdaters.blogDetail.jumpTo
    ),
    search: route(
      localizedRouteUpdaters.search.url,
      localizedRouteUpdaters.search.jumpTo
    ),
    dashboard: route(
      localizedRouteUpdaters.dashboard.url,
      localizedRouteUpdaters.dashboard.jumpTo
    ),
    collectionDetail: route(
      localizedRouteUpdaters.collectionDetail.url,
      localizedRouteUpdaters.collectionDetail.jumpTo
    ),
    knowledgeOverview: route(
      localizedRouteUpdaters.knowledgeOverview.url,
      localizedRouteUpdaters.knowledgeOverview.jumpTo
    ),
    knowledgeTypeOverview: route(
      localizedRouteUpdaters.knowledgeTypeOverview.url,
      localizedRouteUpdaters.knowledgeTypeOverview.jumpTo
    ),
    knowledgeDetail: route(
      localizedRouteUpdaters.knowledgeDetail.url,
      localizedRouteUpdaters.knowledgeDetail.jumpTo
    ),
    seasonalCalendar: route(
      localizedRouteUpdaters.seasonalCalendar.url,
      localizedRouteUpdaters.seasonalCalendar.jumpTo
    ),
    contact: route(
      localizedRouteUpdaters.contact.url,
      localizedRouteUpdaters.contact.jumpTo
    ),
    accountDetails: route(
      localizedRouteUpdaters.accountDetails.url,
      localizedRouteUpdaters.accountDetails.jumpTo
    ),
    upgrade: route(
      localizedRouteUpdaters.upgrade.url,
      localizedRouteUpdaters.upgrade.jumpTo
    ),
    page: route(
      localizedRouteUpdaters.page.url,
      localizedRouteUpdaters.page.jumpTo
    ),
    dishesOverview: route(
      localizedRouteUpdaters.dishesOverview.url,
      localizedRouteUpdaters.dishesOverview.jumpTo
    ),
    dishesDetail: route(
      localizedRouteUpdaters.dishesDetail.url,
      localizedRouteUpdaters.dishesDetail.jumpTo
    ),

    subscriptionSuccessRedirect: route(
      localizedRouteUpdaters.subscriptionSuccessRedirect.url,
      localizedRouteUpdaters.subscriptionSuccessRedirect.jumpTo
    ),
    subscriptionSuccess: route(
      localizedRouteUpdaters.subscriptionSuccess.url,
      localizedRouteUpdaters.subscriptionSuccess.jumpTo
    ),
    subscriptionFailureRedirect: route(
      localizedRouteUpdaters.subscriptionFailureRedirect.url,
      localizedRouteUpdaters.subscriptionFailureRedirect.jumpTo
    ),
    subscriptionFailure: route(
      localizedRouteUpdaters.subscriptionFailure.url,
      localizedRouteUpdaters.subscriptionFailure.jumpTo
    ),
    subscriptionCancelRedirect: route(
      localizedRouteUpdaters.subscriptionCancelRedirect.url,
      localizedRouteUpdaters.subscriptionCancelRedirect.jumpTo
    ),
    subscriptionCancel: route(
      localizedRouteUpdaters.subscriptionCancel.url,
      localizedRouteUpdaters.subscriptionCancel.jumpTo
    ),
    subscriptionStopPayment: route(
      localizedRouteUpdaters.subscriptionStopPayment.url,
      localizedRouteUpdaters.subscriptionStopPayment.jumpTo
    ),
    changePaymentMethodSuccessRedirect: route(
      localizedRouteUpdaters.changePaymentMethodSuccessRedirect.url,
      localizedRouteUpdaters.changePaymentMethodSuccessRedirect.jumpTo
    ),
    changePaymentMethodSuccess: route(
      localizedRouteUpdaters.changePaymentMethodSuccess.url,
      localizedRouteUpdaters.changePaymentMethodSuccess.jumpTo
    ),
    changePaymentMethodFailureRedirect: route(
      localizedRouteUpdaters.changePaymentMethodFailureRedirect.url,
      localizedRouteUpdaters.changePaymentMethodFailureRedirect.jumpTo
    ),
    changePaymentMethodFailure: route(
      localizedRouteUpdaters.changePaymentMethodFailure.url,
      localizedRouteUpdaters.changePaymentMethodFailure.jumpTo
    ),
    changePaymentMethodCancelRedirect: route(
      localizedRouteUpdaters.changePaymentMethodCancelRedirect.url,
      localizedRouteUpdaters.changePaymentMethodCancelRedirect.jumpTo
    ),
    changePaymentMethodCancel: route(
      localizedRouteUpdaters.changePaymentMethodCancel.url,
      localizedRouteUpdaters.changePaymentMethodCancel.jumpTo
    ),

    payOpenInvoiceSuccessRedirect: route(
      localizedRouteUpdaters.payOpenInvoiceSuccessRedirect.url,
      localizedRouteUpdaters.payOpenInvoiceSuccessRedirect.jumpTo
    ),
    payOpenInvoiceSuccess: route(
      localizedRouteUpdaters.payOpenInvoiceSuccess.url,
      localizedRouteUpdaters.payOpenInvoiceSuccess.jumpTo
    ),
    payOpenInvoiceFailureRedirect: route(
      localizedRouteUpdaters.payOpenInvoiceFailureRedirect.url,
      localizedRouteUpdaters.payOpenInvoiceFailureRedirect.jumpTo
    ),
    payOpenInvoiceFailure: route(
      localizedRouteUpdaters.payOpenInvoiceFailure.url,
      localizedRouteUpdaters.payOpenInvoiceFailure.jumpTo
    ),
    payOpenInvoiceCancelRedirect: route(
      localizedRouteUpdaters.payOpenInvoiceCancelRedirect.url,
      localizedRouteUpdaters.payOpenInvoiceCancelRedirect.jumpTo
    ),
    payOpenInvoiceCancel: route(
      localizedRouteUpdaters.payOpenInvoiceCancel.url,
      localizedRouteUpdaters.payOpenInvoiceCancel.jumpTo
    ),

    register: route(
      localizedRouteUpdaters.register.url,
      localizedRouteUpdaters.register.jumpTo
    ),
    registerStudent: route(
      localizedRouteUpdaters.registerStudent.url,
      localizedRouteUpdaters.registerStudent.jumpTo
    ),
    registerPromo: route(
      localizedRouteUpdaters.registerPromo.url,
      localizedRouteUpdaters.registerPromo.jumpTo
    ),
    activateAccount: route(
      localizedRouteUpdaters.activateAccount.url,
      localizedRouteUpdaters.activateAccount.jumpTo
    ),
    resetPassword: route(
      localizedRouteUpdaters.resetPassword.url,
      localizedRouteUpdaters.resetPassword.jumpTo
    ),
    requestResetPassword: route(
      localizedRouteUpdaters.requestResetPassword.url,
      localizedRouteUpdaters.requestResetPassword.jumpTo
    ),
    login: route(
      localizedRouteUpdaters.login.url,
      localizedRouteUpdaters.login.jumpTo
    ),
    logout: route(
      localizedRouteUpdaters.logout.url,
      localizedRouteUpdaters.logout.jumpTo
    ),

    studentSubscription: route(
      localizedRouteUpdaters.studentSubscription.url,
      localizedRouteUpdaters.studentSubscription.jumpTo
    ),
    updatePayment: route(
      localizedRouteUpdaters.updatePayment.url,
      localizedRouteUpdaters.updatePayment.jumpTo),

    updatePaymentRedirect: route(
      localizedRouteUpdaters.updatePaymentRedirect.url,
      localizedRouteUpdaters.updatePaymentRedirect.jumpTo),

    thankYouUpdatePayment: route(
      localizedRouteUpdaters.thankYouUpdatePayment.url,
      localizedRouteUpdaters.thankYouUpdatePayment.jumpTo)
  }
}

export const routerWidget = (language: string) =>
  router<Updater<RootState>>()(routesArray(language))
